import { createRef, useEffect, useState } from 'react';
import type { RefObject } from 'react';

interface UseListScrollIntoViewParams {
  itemCount: number;
  activeKey: number | null | undefined;
}

interface UseListScrollIntoViewReturn {
  elRefs: Array<RefObject<HTMLDivElement>>;
}

const useListScrollIntoView = ({
  itemCount,
  activeKey
}: UseListScrollIntoViewParams): UseListScrollIntoViewReturn => {
  const [elRefs, setElRefs] = useState<Array<RefObject<HTMLDivElement>>>([]);

  useEffect(() => {
    setElRefs(prev =>
      Array.from({ length: itemCount || 0 }, (_, i) => prev[i] || createRef())
    );
  }, [itemCount, activeKey]);

  useEffect(() => {
    if (activeKey && elRefs?.length) {
      elRefs
        .find(
          item => activeKey === Number(item.current?.getAttribute('data-key'))
        )
        ?.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, [activeKey, elRefs]);

  return { elRefs };
};

export default useListScrollIntoView;
